// @ts-nocheck
import React from 'react';

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('RootErrorBoundary caught:', error, info?.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            background: '#121212',
            color: '#f3f3f3',
            fontFamily: 'Inter, system-ui, sans-serif',
          }}
        >
          <div style={{ maxWidth: 480, textAlign: 'center' }}>
            <h1 style={{ fontSize: 20, marginBottom: 12 }}>Something went wrong</h1>
            <p style={{ marginBottom: 20, lineHeight: 1.5, color: '#848e9c' }}>
              The app hit a rendering error. Try a hard refresh (Ctrl+Shift+R). If this persists
              after a dev server restart, check the browser console for details.
            </p>
            <button
              type="button"
              onClick={() => window.location.assign('/')}
              style={{
                padding: '10px 18px',
                borderRadius: 8,
                border: 'none',
                background: '#01BC8D',
                color: '#fff',
                cursor: 'pointer',
                fontWeight: 600,
              }}
            >
              Reload home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default RootErrorBoundary;
